import { render } from "./PredictionCardChartItem.vue?vue&type=template&id=35b1055a&scoped=true&ts=true"
import script from "./PredictionCardChartItem.vue?vue&type=script&lang=ts"
export * from "./PredictionCardChartItem.vue?vue&type=script&lang=ts"

import "./PredictionCardChartItem.vue?vue&type=style&index=0&id=35b1055a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b1055a"]])

export default __exports__